const Home = () => import(/* webpackChunkName: "home" */ '@/views/home/Home.vue');
const Analysis = () => import(/* webpackChunkName: "report" */ '@/views/report/Analysis.vue');
const PvGeneration = () => import(/* webpackChunkName: "report" */ '@/views/report/PvGeneration.vue');
const Consumption = () => import(/* webpackChunkName: "report" */ '@/views/report/Consumption.vue');
const Battery = () => import(/* webpackChunkName: "report" */ '@/views/report/Battery.vue');
const Grid = () => import(/* webpackChunkName: "report" */ '@/views/report/Grid.vue');
const HomeAppliance = () => import(/* webpackChunkName: "homeappliance" */ '@/views/homeAppliance/HomeAppliance.vue');
const HomeApplianceChart = () => import(/* webpackChunkName: "homeappliance" */ '@/views/homeAppliance/HomeApplianceChart.vue');
const ACModule = () => import(/* webpackChunkName: "acmodule" */ '@/views/acModule/ACModule.vue');
const EnergyManagement = () => import(/* webpackChunkName: "energyManagement" */ '@/views/energyManagement/EnergyManagement.vue');
// Redirect 페이지
const PageNotFound = () => import(/* webpackChunkName: "error" */ '@hems/component/src/redirectPages/NotFoundPage.vue');
const webRoutes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/analysis',
        name: 'Analysis',
        component: Analysis,
    },
    {
        path: '/report/pvgeneration',
        name: 'PvGeneration',
        component: PvGeneration,
    },
    {
        path: '/report/consumption',
        name: 'Consumption',
        component: Consumption,
    },
    {
        path: '/report/battery',
        name: 'Battery',
        component: Battery,
    },
    {
        path: '/report/grid',
        name: 'Grid',
        component: Grid,
    },
    {
        path: '/homeAppliance',
        name: 'HomeAppliance',
        component: HomeAppliance,
    },
    {
        path: '/homeApplianceChart',
        name: 'HomeApplianceChart',
        component: HomeApplianceChart,
    },
    {
        path: '/ACModule',
        name: 'ACModule',
        component: ACModule,
    },
    {
        path: '/energyManagement',
        name: 'EnergyManagement',
        component: EnergyManagement,
    },
    {
        path: '/redirect/PageNotFound',
        name: 'PageNotFound',
        component: PageNotFound,
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/redirect/PageNotFound',
    },
];
export default webRoutes;
